import { useLog } from "~/domain/datastores";
import { selectData } from "~/utils";
import { usePlayerConfig } from "./usePlayerConfig";

export function usePlayerLog() {
  const { logId } = usePlayerConfig();

  return useLog(logId, { select: selectData });
}
